export default "__VITE_ASSET__DhZbUrft__"